var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11141 1.67074C7.40168 1.64053 7.69818 1.625 8.00024 1.625C11.265 1.625 13.8801 3.43915 15.0002 6C14.724 6.6315 14.3569 7.2176 13.9115 7.74228M4.16398 2.57465C2.73593 3.35253 1.63102 4.55787 1.00024 6C2.12034 8.56085 4.73547 10.375 8.00024 10.375C9.42654 10.375 10.7288 10.0288 11.8367 9.42526M6.51538 4.67412C6.13532 5.01343 5.90024 5.4822 5.90024 6C5.90024 7.03553 6.84045 7.875 8.00024 7.875C8.58018 7.875 9.1052 7.66511 9.48523 7.32577",
    stroke: "#283E24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.40015 1L13.6001 11",
    stroke: "#283E24",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeInactive);
export default __webpack_public_path__ + "static/media/eye-inactive.6a9f84118c95ae1b4fcdb9884acbedaf.svg";
export { ForwardRef as ReactComponent };